<template>
  <div class="footer-box">
    <div class="container-wrap">
      <p class="info" style="padding-top: 36px">
        主办单位:钱江源-百山祖国家公园百山祖管理局
      </p>
      <p class="info">承办单位:丽水传媒集团有限公司</p>
      <div class="view-box" style="float: left">
        <p class="view">技术支持:丽水传媒集团有限公司</p>
        <!-- <div class="">此处为网站统计的图标</div> -->
      </div>
      <div class="view-box right">
        <!-- <p class="view">访问量: 574067</p> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    props: {},
    data() {
      return {};
    },
    mounted() {},
  };
</script>

<style lang="less" scoped>
  .footer-box {
    width: 100%;
    height: 185px;
    background-color: #353533;
  }
  .container-wrap {
  }
  .info {
    color: #fff;
    margin-left: 15px;
    font-size: 16px;
    line-height: 30px;
  }
  .view-box {
    display: flex;
    justify-content: space-between;
    margin: 6px 15px 0;
  }
  .view {
    font-size: 14px;
    color: #999;
  }
  .right {
    float: right;
  }
  @media (max-width: 1200px) {
    .container-wrap {
      width: 100%;
    }
    .info {
      font-size: 12px;
    }
    .right {
      float: left;
    }
    .view {
      font-size: 12px;
    }
  }
</style>
